import React from 'react';
import { Placeholder } from '@components/basics/Placeholder';
import { Box3D } from '@components/icons/Illustrations/box3d';
import { EyeStars } from '@components/icons/Illustrations/eyeStars';
import { Plus3D } from '@components/icons/Illustrations/plus3d';
import { useConnectedAuth } from '@context/auth/connected';
import { trackClickEvent } from '@lib/analytics';

export const FeedEmpty = () => {
  return (
    <Placeholder
      illustration={<Plus3D />}
      subHeading={"It's a bit quiet in here"}
      text="Follow a few frens to get some sounds up in this feed. Start by following top artists and collectors!"
      buttonLabel="Go to Charts"
      href="/charts?type=collectors"
      divider
      mainFeed
    />
  );
};

export const FeedEmptyAuth = () => {
  const { login } = useConnectedAuth();

  function onClick() {
    trackClickEvent({
      event: 'Sign in Clicked',
      properties: {
        sourceComponent: 'Feed',
      },
    });
    login();
  }

  return (
    <Placeholder
      illustration={<Box3D />}
      subHeading={"Looks like your wallet isn't connected"}
      text="Sign in to view your personalized feed."
      buttonLabel="Sign in"
      onClick={onClick}
      divider
      mainFeed
    />
  );
};
export const FeedError = ({
  divider = false,
  mainFeed = false,
}: {
  divider?: boolean;
  mainFeed?: boolean;
}) => {
  return (
    <Placeholder
      illustration={<EyeStars />}
      subHeading={"Something isn't working here"}
      text="Don’t worry we’re looking into it. Until then, discover more sounds on our home page."
      buttonLabel="Go to home page"
      href="/"
      divider={divider}
      mainFeed={mainFeed}
    />
  );
};
